/** @format */

import {BUTTON_WIDTH, TARGET_BUTTONS_GAP_PX} from '../../constants/scatters';

/**
 * Рассчитает расстояние между кнопками в днях, зная длину контейнера в пикселях и общее число дней.
 * @param containerWidth - длина контейнера (от 1-го дня до последнего включительно)
 * @param periodDays - общее число дней в диапазоне
 * ВАЖНО: не пытайтесь передать periodDays меньше, чем их выводится на графике внутри контейнера
 */

const calcDaysRange = (containerWidth: number, periodDays: number): number => {
  if (containerWidth <= 0) {
    return periodDays;
  }

  const buttonsCount = Math.floor(
    (containerWidth + TARGET_BUTTONS_GAP_PX) / (BUTTON_WIDTH + TARGET_BUTTONS_GAP_PX),
  );
  return Math.ceil(periodDays / buttonsCount);
};

export {calcDaysRange};
